// HubSpot chat needs to have "I don't care about cookies" browser addon disabled, and Firefox "Enhanced tracking protection" needs to be off for given site

import { getApplicationContext } from './applicationContext';

export function initializeHubSpotChat() {  
    moveHubSpotChatOutOfBody();
    setHubSpotChatIdentification();
    refreshHubSpotChatVisibility();
}

const hubSpotChatContainerId = 'hubspot-messages-iframe-container';

function moveHubSpotChatOutOfBody() { // taken from https://stackoverflow.com/a/53342285/379279
    let targetNode = document.body
    let config = { childList: true }
    let callback = function () {
        if (document.body.querySelector(`#${hubSpotChatContainerId}`)) {
            document.documentElement.appendChild(
                document.getElementById(hubSpotChatContainerId)!
            );
            observer.disconnect();

            refreshHubSpotChatVisibility();
        }
    }

    let observer = new MutationObserver(callback);
    if (!document.querySelector(`html > #${hubSpotChatContainerId}`)) {
        observer.observe(targetNode, config)
    }
}

function setHubSpotChatIdentification() {
    // @ts-ignore
    var _hsq: Array = window._hsq = window._hsq || [];
    const appContext = getApplicationContext();
    if (appContext.userEmail) {

        _hsq.push(["identify", {
            email: appContext.userEmail
        }]);
    }

    _hsq.push(["trackPageView"]);
}

export function openChat() {
    // @ts-ignore
    window.HubSpotConversations.widget.open();    
}

function refreshHubSpotChatVisibility() {
    let hubSpotContainer = document.getElementById(hubSpotChatContainerId);
    if (!hubSpotContainer) return;

    const appContext = getApplicationContext();
    if (appContext.isPrimeMaintenanceSubscriber) {
        hubSpotContainer.style.setProperty("display", "", "");
    }
    else {
        hubSpotContainer.style.setProperty("display", "none", "important");
    }
}